import axiosInstance from 'src/utils/axios';
import { useQuery } from '@tanstack/react-query';
import { GAME_ENTRY_FEE_REWARD } from 'src/constants/queryKeys';

export const networkCreateGameEntryFeeRewards = async (gameEntryFeeRewards) => {
  const res = await axiosInstance.post('/GameEntryFeeRewards/Insert', gameEntryFeeRewards);
  return res;
};
export const networkUpdateGameEntryFeeRewards = async (id, gameEntryFeeRewards) => {
  const res = await axiosInstance.post(`/GameEntryFeeRewards/Update/${id}`, gameEntryFeeRewards);
  return res;
};
export const networkRemoveGameEntryFeeRewards = async (id) => {
  const res = await axiosInstance.post(`/GameEntryFeeRewards/Remove/${id}`);
  return res;
};
export const networkInfoGameEntryFeeRewards = async (id) => {
  const res = await axiosInstance.post(`/GameEntryFeeRewards/Info/${id}`);
  return res;
};
export const networkGetListGameEntryFeeRewards = async (payload, pageIndex, pageSize) => {
  const res = await axiosInstance.post(`/GameEntryFeeRewards/List/${pageIndex}/${pageSize}`, payload);
  return res;
};
export function useFetchGameEntryFeeRewardsList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [GAME_ENTRY_FEE_REWARD, payload, pageIndex],
    queryFn: () => networkGetListGameEntryFeeRewards(payload, pageIndex, pageSize),
  });
}
